module.exports = __webpack_public_path__ + "img/botswana.6937100.webp";